import { render, staticRenderFns } from "./EditWarehouseModal.vue?vue&type=template&id=a70cd2cc&scoped=true&"
import script from "./EditWarehouseModal.vue?vue&type=script&lang=js&"
export * from "./EditWarehouseModal.vue?vue&type=script&lang=js&"
import style0 from "./EditWarehouseModal.vue?vue&type=style&index=0&id=a70cd2cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70cd2cc",
  null
  
)

export default component.exports